import React from 'react';
import CartEditor from './Cart.editor';
import CartProperties from './Cart.properties';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { CartSkinnable } from './CartSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { COMPONENT_TYPES } from '../../../constants';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(CartSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const CartWrapper: React.FC<any> = (props) => {
  const selectedSkin = props.skin || props.componentProps?.skin || 'basic';
  
  return (
    <ComponentSkinWrapper 
      component={CartSkinnable}
      componentData={props}
      skinId={selectedSkin}
      mode={props.isPreview ? 'editor' : 'preview'}
      editorProps={props}
    />
  );
};

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.CART || 'Cart',
  component: CartWrapper,
  editorComponent: CartEditor,
  properties: CartProperties,
  defaultProps: {
    style: {
      backgroundColor: '#fff',
      width: '100%',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    componentProps: {
      skin: 'basic',
      title: '장바구니',
      emptyText: '장바구니가 비어있습니다.',
      showStock: true,
      freeShippingLimit: 50000,
      shippingFee: 3000
    }
  },
  category: 'ecommerce',
  icon: '🛒',
  name: '장바구니',
  skinnable: CartSkinnable
});

// 컴포넌트 및 타입 내보내기
export { CartWrapper as CartComponent };
export { default as CartEditor } from './Cart.editor';
export { default as CartProperties } from './Cart.properties';
export * from './Cart.types';
export * from './Cart.adapter';